import { __assign, __rest } from "tslib";
// DS1.10
import React, { useCallback } from 'react';
import c from 'classnames';
import { useReverseTheme } from '@wix/da-react-context/pkg/ThemeContext';
import SimpleTooltipContent from '../../SimpleTooltipContent';
import PopperPositionedPopover from '../../../popper/PopperPositionedPopover';
import { usePopoverOnInteraction } from '../../../popper/hooks/usePopoverOnInteraction';
import PopoverWrapper from '../../../popper/PopoverWrapper';
import s from './SimpleTooltip.scss';
var SimpleTooltip = function (_a) {
    var text = _a.text, children = _a.children, prefix = _a.prefix, postfix = _a.postfix, width = _a.width, _b = _a.forceVisible, forceVisible = _b === void 0 ? false : _b, className = _a.className, rest = __rest(_a, ["text", "children", "prefix", "postfix", "width", "forceVisible", "className"]);
    var _c = usePopoverOnInteraction({ listenOnClicks: true, listenOnHover: true }), isVisible = _c.isVisible, onClick = _c.onClick, onMouseEnter = _c.onMouseEnter, onMouseLeave = _c.onMouseLeave, onClose = _c.onClose;
    var reverseTheme = useReverseTheme();
    var renderPopover = useCallback(function (_a) {
        var effectivePlacement = _a.effectivePlacement, effectiveSecondaryPlacement = _a.effectiveSecondaryPlacement, rootRef = _a.rootRef, arrowRef = _a.arrowRef, contentStyle = _a.contentStyle, arrowStyle = _a.arrowStyle, contentAttributes = _a.contentAttributes, arrowAttributes = _a.arrowAttributes, updatePositioning = _a.updatePositioning;
        return (React.createElement(PopoverWrapper, { contentClassName: s['popover-wrapper'], width: width, onClickOutside: onClose, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, effectivePlacement: effectivePlacement, effectiveSecondaryPlacement: effectiveSecondaryPlacement, rootRef: rootRef, arrowRef: arrowRef, contentStyle: contentStyle, arrowStyle: arrowStyle, contentAttributes: contentAttributes, arrowAttributes: arrowAttributes, updatePositioning: updatePositioning, forceTheme: reverseTheme },
            React.createElement(SimpleTooltipContent, { prefix: prefix, postfix: postfix }, text)));
    }, [
        width,
        text,
        prefix,
        postfix,
        onMouseEnter,
        onMouseLeave,
        onClose,
        reverseTheme,
    ]);
    return (React.createElement(PopperPositionedPopover, __assign({ isVisible: isVisible || forceVisible, onReferenceClick: onClick, onReferenceMouseEnter: onMouseEnter, onReferenceMouseLeave: onMouseLeave, className: c(s['root'], className), renderPopover: renderPopover }, rest), children));
};
SimpleTooltip.displayName = 'SimpleTooltip';
export default SimpleTooltip;
//# sourceMappingURL=SimpleTooltip.js.map